import { apiGet, apiDelete, apiPatch, apiPost, apiPut } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export const groupService = {
  // get All Groups
  getAll: (pageSize = 0, current = 1, searchInput = "", sortColumn = "", filter = JSON.stringify([])) => apiGet(domainUrl(`/v1/hospital/list?limit=${pageSize}&page=${current}&hospitalName=${searchInput}&sortBy=${sortColumn}&specialty=${encodeURIComponent(filter)}`)),

  // create group
  create: (payload) => apiPost(domainUrl(`/v1/hospital`), payload),

  // get group by id
  getById: (id) => apiGet(domainUrl(`/v1/hospital/${id}`)),

  // update group
  update: (id, payload) => apiPut(domainUrl(`/v1/hospital/update/${id}`), payload),

  // delete group
  delete: (payload) => apiPost(domainUrl(`/v1/hospital/delete`), payload),

  addMemberToGroup: (payload) => apiPost(domainUrl(`/v1/hospital/add-members`), payload),

  removeMembersFromGroup: (payload) => apiPost(domainUrl(`/v1/hospital/remove-members`), payload),

  getNonGroupMembers: (payload) => apiGet(domainUrl(`/v1/hospital/non-group-members`), payload),

  getGroupMembers: (name = "") => apiGet(domainUrl(`/v1/hospital/group-members?name=${name}`)),

  getGroupSpecialty: () => apiGet(domainUrl(`/v1/hospital/my-group-specialty`))

};
